"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var common_util_1 = require("./util/common.util");
var indicator_view_model_1 = require("./model/indicator/indicator-view.model");
var entity_search_model_1 = require("./model/entity-search.model");
var of_1 = require("rxjs/observable/of");
/**
 * @author Gevorg Avetisyan on 12/2/2018.
 */
var DummyEntutySearchIndicator = /** @class */ (function () {
    function DummyEntutySearchIndicator() {
    }
    DummyEntutySearchIndicator.prototype.getIndicatorFromEntitySearch = function (filter, paging, languageId) {
        return of_1.of(Convert.convertToEntitySearchToIndicatorView(indicators));
    };
    DummyEntutySearchIndicator.prototype.getIndicators = function (systemName, filter, paging, languageId, sortField, sortOrder) {
        return undefined;
    };
    DummyEntutySearchIndicator = __decorate([
        core_1.Injectable()
    ], DummyEntutySearchIndicator);
    return DummyEntutySearchIndicator;
}());
exports.DummyEntutySearchIndicator = DummyEntutySearchIndicator;
var Convert = /** @class */ (function () {
    function Convert() {
    }
    Convert.convertToEntitySearchToIndicatorView = function (entitySearch) {
        var indicators = [];
        entitySearch.data.forEach(function (indicator) {
            indicators.push(new indicator_view_model_1.IndicatorView(indicator['id'], new idm_crosscutting_concepts_frontend_1.MultilingualString(common_util_1.CommonUtil.toMap(indicator['name'])), indicator['typeId'], indicator['representId'], indicator['contextId']));
        });
        return new entity_search_model_1.EntitySearchModel(entitySearch.meta.totalRowCount, indicators);
    };
    Convert.convertJsonToEntitySearchModel = function (entitySearch) {
        var indicatorObj = [];
        entitySearch.data.forEach(function (indicator) {
            indicator['name'] = new idm_crosscutting_concepts_frontend_1.MultilingualString(common_util_1.CommonUtil.toMap(indicator['name']));
            indicatorObj.push(indicator);
        });
        return new entity_search_model_1.EntitySearchModel(entitySearch.meta.totalRowCount, indicatorObj);
    };
    Convert.convertNumberArrayToString = function (array, separator) {
        var res = "";
        var len = array.length;
        if (len > 0) {
            res += array[0];
        }
        for (var i = 1; i < len; ++i) {
            res += (separator + array[i]);
        }
        return res;
    };
    Convert.multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
    return Convert;
}());
exports.Convert = Convert;
var indicators = {
    "data": [
        {
            "indicatorId": 4971,
            "name": {
                "7": "Indicator_Name_Eng1540200516362",
                "8": "Indicator_Name_Eng1540200516362",
                "9": "Indicator_Name_Eng1540200516362",
                "51": "Indicator_Name_Eng1540200516362"
            },
            "typeId": 2,
            "id": 4971,
            "representId": 1
        },
        {
            "indicatorId": 4961,
            "name": {
                "7": "Indicator_Name_Eng1539989484869",
                "8": "Indicator_Name_Fra1539989484869",
                "9": "Indicator_Name_Spa1539989484869",
                "51": "Indicator_Name_Ara1539989484869"
            },
            "typeId": 2,
            "id": 4961,
            "representId": 1
        },
        {
            "indicatorId": 3631,
            "name": {
                "7": "Indicator_Name_Eng1538167889508",
                "8": "Indicator_Name_Eng1538167889508",
                "9": "Indicator_Name_Eng1538167889508",
                "51": "Indicator_Name_Eng1538167889508"
            },
            "typeId": 2,
            "id": 3631,
            "representId": 1
        },
        {
            "indicatorId": 3636,
            "name": {
                "7": "Indicator_Name_Eng1538168885003",
                "8": "Indicator_Name_Eng1538168885003",
                "9": "Indicator_Name_Eng1538168885003",
                "51": "Indicator_Name_Eng1538168885003"
            },
            "typeId": 2,
            "id": 3636,
            "representId": 1
        },
        {
            "indicatorId": 4975,
            "name": {
                "7": "terf",
                "8": "terf",
                "9": "terf",
                "51": "terf"
            },
            "typeId": 3,
            "id": 4975,
            "representId": 2
        },
        {
            "indicatorId": 3644,
            "name": {
                "7": "Indicator_Name_Eng1538169058962",
                "8": "Indicator_Name_Fra1538169058962",
                "9": "Indicator_Name_Spa1538169058962",
                "51": "Indicator_Name_Ara1538169058962"
            },
            "typeId": 2,
            "id": 3644,
            "representId": 1
        },
        {
            "indicatorId": 3652,
            "name": {
                "7": "Indicator_Name_Eng1538212622980",
                "8": "Indicator_Name_Eng1538212622980",
                "9": "Indicator_Name_Eng1538212622980",
                "51": "Indicator_Name_Eng1538212622980"
            },
            "typeId": 2,
            "id": 3652,
            "representId": 1
        },
        {
            "indicatorId": 4985,
            "name": {
                "7": "Indicator_Name_Eng1540221859035",
                "8": "Indicator_Name_Eng1540221859035",
                "9": "Indicator_Name_Eng1540221859035",
                "51": "Indicator_Name_Eng1540221859035"
            },
            "typeId": 2,
            "id": 4985,
            "representId": 1
        },
        {
            "indicatorId": 3670,
            "name": {
                "7": "Indicator_Name_Eng1538214000700",
                "8": "Indicator_Name_Eng1538214000700",
                "9": "Indicator_Name_Eng1538214000700",
                "51": "Indicator_Name_Eng1538214000700"
            },
            "typeId": 2,
            "id": 3670,
            "representId": 1
        },
        {
            "indicatorId": 4998,
            "name": {
                "7": "Indicator_Name_Eng1540248498428",
                "8": "Indicator_Name_Fra1540248498428",
                "9": "Indicator_Name_Spa1540248498428",
                "51": "Indicator_Name_Ara1540248498428"
            },
            "typeId": 2,
            "id": 4998,
            "representId": 1
        }
    ],
    "meta": {
        "totalRowCount": 3621
    }
};
//# sourceMappingURL=dummy-me-entity-search.service.js.map